import CheckFilled from '~/icons/CheckFilled';
import { ListItem } from './CategoryCard.styles';

type OwnProps = {
  name: string;
};

export default function Feature({ name }: OwnProps) {
  return (
    <div className="flex flex-row items-center justify-start">
      <CheckFilled className="text-green-2 -:h-16 -:w-16" />
      <ListItem>{name}</ListItem>
    </div>
  );
}
